export { default } from './DocumentHead';
